import { Button, Root } from './primitives'

export const Radio = { Button, Root }
